module.exports = __webpack_public_path__ + "media/metronic/_theme/media/error/bg2-9cc269f7ff7fae72ce196a564496dd8b.jpg";